// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__ogh9-","icon":"Spinner_icon__KeJjs","spinnerRotate":"Spinner_spinnerRotate__HbbpA","text":"Spinner_text__8EFG2"};